import * as yup from "yup";

export default yup.object().shape({
  HiringTitle: yup.string().required("Please enter the title."),
  HiringDeadline: yup.string().required("Please select Dead Line."),
  HiringContent: yup.string().required("Please enter the content."),
});
